export const duplicateHDImage = (
  choiceHDImages,
  updatedHDImages,
  originalIndex,
  targetInsertIndex,
) => {
  for (let i = 0; i < updatedHDImages.length; i++) {
    if (updatedHDImages[i].index >= targetInsertIndex) {
      updatedHDImages[i] = {
        ...updatedHDImages[i],
        index: updatedHDImages[i].index + 1,
      }
    }
  }

  const hdImageToDuplicate = choiceHDImages.find(
    img => img.index === originalIndex,
  )
  if (hdImageToDuplicate) {
    const oldFilename = hdImageToDuplicate.filename
    const lastUnderscore = oldFilename.lastIndexOf('_')
    const lastDot = oldFilename.lastIndexOf('.')
    const newFilename =
      oldFilename.slice(0, lastUnderscore) +
      '_' +
      Date.now() +
      oldFilename.slice(lastDot)

    updatedHDImages.push({
      ...hdImageToDuplicate,
      index: targetInsertIndex,
      filename: newFilename,
      status: 'duplicate',
    })
  }

  return updatedHDImages
}

export const deleteAllHDImages = choiceHDImages => {
  const updatedHDImages = []

  choiceHDImages.forEach(item => {
    // Revoke blob URLs for deleted images
    if (item.imageUrl.startsWith('blob:')) {
      revokeUnusedBlobURL(choiceHDImages, item)
    }

    // Add back deleted items that are Cloudflare URLs
    if (item.status !== 'duplicate' && !item.imageUrl.startsWith('blob:')) {
      updatedHDImages.push({
        ...item,
        status: 'delete',
        index: -1,
      })
    }
  })

  return updatedHDImages
}

export const deleteMultipleHDImages = (choiceHDImages, indexesToDelete) => {
  const itemsToDelete = choiceHDImages.filter(item =>
    indexesToDelete.includes(item.index),
  )

  // Revoke blob URLs for deleted images
  itemsToDelete.forEach(item => {
    if (item.imageUrl.startsWith('blob:')) {
      revokeUnusedBlobURL(choiceHDImages, item)
    }
  })

  const updatedHDImages = choiceHDImages
    .filter(item => !indexesToDelete.includes(item.index)) // Remove deleted
    .map(item => ({
      ...item,
      // Calculate new index based on how many deleted indexes come before it
      index:
        item.index -
        indexesToDelete.filter(deleteIndex => deleteIndex < item.index).length,
    }))

  // Add back deleted items that are Cloudflare URLs
  itemsToDelete.forEach(item => {
    if (item.status !== 'duplicate' && !item.imageUrl.startsWith('blob:')) {
      updatedHDImages.push({
        ...item,
        status: 'delete',
        index: -1,
      })
    }
  })

  return updatedHDImages
}

export const clearMultipleHDImages = (choiceHDImages, indexesToClear) => {
  const itemsToClear = choiceHDImages.filter(item =>
    indexesToClear.includes(item.index),
  )

  // Revoke blob URLs for cleared images
  itemsToClear.forEach(item => {
    if (item.imageUrl.startsWith('blob:')) {
      revokeUnusedBlobURL(choiceHDImages, item)
    }
  })

  const updatedHDImages = choiceHDImages.flatMap(item => {
    if (indexesToClear.includes(item.index)) {
      if (item.status !== 'duplicate' && !item.imageUrl.startsWith('blob:')) {
        return [
          {
            ...item,
            status: 'delete',
            index: -1,
          },
        ]
      }
      return []
    }
    return [item]
  })

  return updatedHDImages
}

export const deleteHDImage = (choiceHDImages, indexToDelete) => {
  // Find and revoke the blob URL before removing
  const removedItem = choiceHDImages.find(item => item.index === indexToDelete)
  if (removedItem) {
    if (removedItem.imageUrl.startsWith('blob:')) {
      revokeUnusedBlobURL(choiceHDImages, removedItem)
    }
  }

  const updatedHDImages = choiceHDImages
    .filter(item => item.index !== indexToDelete)
    .map(item => ({
      ...item,
      index: item.index > indexToDelete ? item.index - 1 : item.index,
    }))

  // Only add back deleted item if it is Cloudflare URL
  if (
    removedItem &&
    removedItem.status !== 'duplicate' &&
    !removedItem.imageUrl.startsWith('blob:')
  ) {
    updatedHDImages.push({
      ...removedItem,
      status: 'delete',
      index: -1,
    })
  }

  return updatedHDImages
}

export const revokeUnusedBlobURL = (choiceHDImages, removedItem) => {
  // Check if this blob URL is used by any other item in the array
  const isUsedElsewhere = choiceHDImages.some(
    item =>
      item.index !== removedItem.index &&
      item.imageUrl === removedItem.imageUrl,
  )
  // Only revoke if not used by any other item
  if (!isUsedElsewhere) {
    URL.revokeObjectURL(removedItem.imageUrl)
  }
}

export const manualSortHDImage = (choiceHDImages, oldIndex, newIndex) => {
  let updatedHDImages = [...choiceHDImages]
  const movedHDImage = updatedHDImages.find(img => img.index === oldIndex)
  updatedHDImages = updatedHDImages.filter(img => img.index !== oldIndex)
  updatedHDImages = updatedHDImages.map(img => {
    if (oldIndex < newIndex) {
      if (img.index > oldIndex && img.index <= newIndex) {
        return { ...img, index: img.index - 1 }
      }
    } else {
      if (img.index >= newIndex && img.index < oldIndex) {
        return { ...img, index: img.index + 1 }
      }
    }
    return img
  })
  if (movedHDImage) {
    updatedHDImages.push({
      ...movedHDImage,
      index: newIndex,
    })
  }
  return updatedHDImages
}
